export default "__VITE_ASSET__Bv6qve32__"